"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const MiddlewareException_1 = tslib_1.__importDefault(require("../models/Exceptions/MiddlewareException"));
const auth_1 = tslib_1.__importDefault(require("./middleware/auth"));
const dispatchActions_1 = tslib_1.__importDefault(require("./middleware/dispatchActions"));
const pageTitle_1 = tslib_1.__importDefault(require("./middleware/pageTitle"));
const guest_1 = tslib_1.__importDefault(require("./middleware/guest"));
function carry(nextArg) {
    if (nextArg === undefined) {
        return;
    }
    throw new MiddlewareException_1.default(nextArg);
}
function initRouter(router, store) {
    router.beforeEach((to, from, next) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        console.group(`Running middleware for ${to.fullPath}...`);
        store.dispatch('startLoading');
        try {
            pageTitle_1.default(to);
            yield guest_1.default(to);
            yield auth_1.default(to, from, carry);
            yield store.dispatch('getMe');
            console.groupEnd();
        }
        catch (e) {
            if (e instanceof MiddlewareException_1.default) {
                return next(e.route);
            }
            console.error(e);
            return next(false);
        }
        finally {
            console.groupEnd();
        }
        console.info(`All middlewares passed, confirming navigation ${to.fullPath}...`);
        return next();
    }));
    router.afterEach((to, from) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        console.group(`Running loaders for ${to.fullPath}...`);
        yield dispatchActions_1.default(to, from, store);
        store.dispatch('stopLoading');
        console.groupEnd();
    }));
    return router;
}
exports.default = initRouter;
//# sourceMappingURL=initRouter.js.map